import PaymentManagerStripe from "./PaymentManagerStripe";
export default PaymentManagerStripe;
